module.exports = __webpack_public_path__ + "media/call-digital.e28b6914.wav";